import { sharedEs } from './es';
import { sharedEsCR } from './esCR';
import { sharedEsUY } from './esUY';
import { sharedPt } from './pt';

export const sharedLocale = {
  pt: sharedPt,
  es: sharedEs,
  'es-CR': sharedEsCR as typeof sharedEs,
  'es-UY': sharedEsUY as typeof sharedEs,
};
